
import $ from 'rgs-jquery';
import ko from 'rgs-knockout';

const notifications = require('notifications');


const notificationsInstance = new (notifications.Notifications)();
module.exports = notificationsInstance;


$(function bindNotifications () {
	const model = notificationsInstance;
	const defaultViewSelector = '#main-notifications';
	const view = $(defaultViewSelector)[0];
	if (view) {
		ko.applyBindings(model, view);
	} else {
		console.info(
			'Default notification view '
				+ defaultViewSelector
				+ ' was not found in DOM. Notifications will not appear.'
		);
	}
});


